import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/solutions/predictive-maintrance/page.tsx");
